import { ACCOUNT_ROLES } from '@/utils/account-service.const';

export const ACTIVE = 'Active';
export const INACTIVE = 'Inactive';
export const INVITED = 'Invited';

export const userStatus = {
	[ACTIVE]: 1,
	[INACTIVE]: 2,
	[INVITED]: 3,
};

export const userStatusToString = {
	1: ACTIVE,
	2: INACTIVE,
	3: INVITED,
};

export const mapRoleToTitle = (roleCode) => ACCOUNT_ROLES[roleCode];
